<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title"> {{'event.migration' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"> #</th>
            <th scope="col">{{'event.title' | translate}}</th>
            <th scope="col"></th>
            <th scope="col">{{'event.event_type' | translate}}</th>
            <th scope="col" style="width: 20%">{{'event.description' | translate}}       </th>
            <th scope="col" style="width: 20%">{{'event.internal_description' | translate}}</th>
            <th scope="col">{{'event.target_group' | translate}}</th>
            <th scope="col">{{'event.responsible' | translate}}</th>
            <th>
              <mat-checkbox [(ngModel)]="all" (change)="selectAll()"></mat-checkbox>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of events; track item; let i = $index) {
            <tr>
              <th scope="row" (click)="openTgDialog(item, index)">
                {{i + 1}}.
              </th>
              <td (click)="openTgDialog(item, index)">
                @if (item.imported) {
                  <mat-icon style="color: green">check_circle_outline</mat-icon>
                }
                <b>{{item.title}}</b>
                @if (item.credits) {
                  <p>{{'(' + item.credits + ' credits)'}}</p>
                }</td>
                <td (click)="openTgDialog(item, index)"><p class="one-line-text" style="color:rgba(193,26,26,0.78)">{{'min : ' + item.minParticipants }}</p> <br>
                <p class="one-line-text" style="color:rgba(54,164,41,0.8)">{{'max : ' + item.maxParticipants}}</p></td>
                @if (item.type) {
                  <td (click)="openTgDialog(item, index)"><p class="one-line-text"><i style="vertical-align: bottom;"
                    [ngStyle]="{'color': item.type.color}"
                    class="material-icons">
                    brightness_1
                  </i> {{item.type.name }}</p></td>
                }
                @if (!item.type) {
                  <td (click)="openTgDialog(item, index)">-</td>
                }
                <td (click)="openTgDialog(item, index)"> {{item.description}}</td>
                <td (click)="openTgDialog(item, index)"> {{item.internalDescription}}</td>
                <td (click)="openTgDialog(item, index)">
                  @for (tg of item.tg; track tg) {
                    <p class="one-line-text">{{tg.ageMask}}</p><br>
                  }
                </td>
                <td (click)="openTgDialog(item, index)">
                  <ng-container>
                    <p class="one-line-text">{{item.user.firstName}}</p>
                    <br>
                      <p class="one-line-text">{{item.user.lastName}}</p>
                    </ng-container>
                  </td>
                  <td>
                    <mat-checkbox (change)="checkAll()" [(ngModel)]="item.selected"></mat-checkbox>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (!msg) {
            <mat-spinner style="margin: auto;"></mat-spinner>
          }
          @if (msg !== 'done') {
            <h2 style="text-align: center;">{{msg | translate}}</h2>
          }
        </div>
      </div>
      <div mat-dialog-actions class="action-button-dialog" style="margin: 1px">
        <button mat-raised-button style="padding: 0px 10px;" class="save-button mat-accent" (click)="saveEvent()">CONFIRM</button>
      </div>
    </div>
